export const FieldOrderAsc = "asc";
export const FieldOrderDesc = "desc";

export type FieldOrderOptions = typeof FieldOrderAsc | typeof FieldOrderDesc;
